import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import axios from "axios";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n";
import Landing from "@/pages/Landing";
import DetectionPage from "@/pages/DetectionPage";
import EquipePage from "@/pages/EquipePage";
import TeamPage from "@/pages/TeamPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import MobileMoney from "@/pages/MobileMoney";
import ResumePayment from "@/pages/ResumePayment";
import Bureau from "@/pages/Bureau";
import EventPage from "@/pages/EventPage";
import RessourcesPage from "@/pages/RessourcesPage";
import CarrieresPage from "@/pages/CarrieresPage";
import CommentInscrirePage from "@/pages/CommentInscrirePage";
import RendezVousPage from "@/pages/RendezVousPage";
import MurLegendesPage from "@/pages/MurLegendesPage";
import Admin from "@/pages/admin/Admin";
import PortailLogin from "@/pages/portail/PortailLogin";
import PortailHome from "@/pages/portail/PortailHome";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function getVisitorId() {
  let vid = localStorage.getItem("d2r-vid");
  if (!vid) {
    vid = crypto.randomUUID();
    localStorage.setItem("d2r-vid", vid);
  }
  return vid;
}

function VisitTracker() {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return;
    axios.post(`${API}/track`, {
      page: location.pathname,
      lang: localStorage.getItem("d2r-lang") || "fr",
      referrer: document.referrer || null,
      vid: getVisitorId(),
    }).catch(() => {});
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <VisitTracker />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/detection" element={<DetectionPage />} />
          <Route path="/equipe" element={<EquipePage />} />
          <Route path="/equipes/:id" element={<TeamPage />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/paiement/mobile-money" element={<MobileMoney />} />
          <Route path="/paiement/bureau" element={<Bureau />} />
          <Route path="/paiement/reprendre" element={<ResumePayment />} />
          <Route path="/evenement" element={<EventPage />} />
          <Route path="/ressources" element={<RessourcesPage />} />
          <Route path="/carrieres" element={<CarrieresPage />} />
          <Route path="/comment-s-inscrire" element={<CommentInscrirePage />} />
          <Route path="/rendez-vous" element={<RendezVousPage />} />
          <Route path="/mur-des-legendes" element={<MurLegendesPage />} />
          <Route path="/portail" element={<PortailLogin />} />
          <Route path="/portail/accueil" element={<PortailHome />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <Toaster position="top-center" theme="dark" />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
